<template>
  <div class="labels-reports-container">
    <LabelsFilters
      ref="filters"
      :labelsData="labels"
      @filter-change="onFilterChange"
    />
    <div class="reports-wrap">
      <div class="bar-section">
        <LabelsBarChart :labelsData="filteredLabels" />
      </div>
      <div class="table-section no-bg">
        <LabelsTable :labelsData="filteredLabels" />
      </div>
    </div>
  </div>
</template>

<script>
import LabelsBarChart from './components/LabelsBarChart';
import LabelsTable from './components/LabelsTable';
import LabelsFilters from './components/LabelsFilters';
import LabelsReportApi from '../../../../api/inbox/historyLabels';

export default {
  name: 'LabelsReportsView',
  components: {
    LabelsFilters,
    LabelsBarChart,
    LabelsTable,
  },
  data() {
    return {
      labels: [],
      filters: {
        customDateRange: '',
        labelNames: [],
        inboxNames: [],
      },
    };
  },
  computed: {
    filteredLabels() {
      const [start, end] = this.filters.customDateRange || [];

      return this.labels.filter(item => {
        const createdDate = new Date(item.created_at);
        const createdDateOnly = new Date(
          createdDate.getFullYear(),
          createdDate.getMonth(),
          createdDate.getDate()
        );

        const startDate = start ? new Date(start) : null;
        const endDate = end ? new Date(end) : null;

        const matchLabel =
          !this.filters.labelNames.length ||
          this.filters.labelNames.includes(item.tag_name);

        const matchDate =
          !startDate ||
          !endDate ||
          (createdDateOnly >= startDate && createdDateOnly <= endDate);

        const matchInbox =
          !this.filters.inboxNames.length ||
          this.filters.inboxNames.includes(item.inbox_name);

        return matchLabel && matchDate && matchInbox;
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.filters.emitFilters();
    });
  },
  methods: {
    async onFilterChange(newFilters) {
      this.filters = {
        ...this.filters,
        ...newFilters,
      };

      try {
        this.labels = [];

        const [start, end] = this.filters.customDateRange || [];

        const formatDate = date => new Date(date).toISOString().split('T')[0];

        const response = await LabelsReportApi.getAll({
          startDate: start ? formatDate(start) : null,
          endDate: end ? formatDate(end) : null,
        });

        this.labels = response.data;
      } catch (error) {
        console.error(this.$t('LABELS_REPORT.ERRORS.FETCH'), error);
      }
    },
  },
};
</script>

<style scoped>
.labels-reports-container {
  display: flex;
  flex-direction: row;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  align-items: flex-start;
}

.labels-reports-container > *:first-child {
  width: 280px;
  flex-shrink: 0;
  margin-right: 24px;
}

.reports-wrap {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  padding: 2vh 2vw 10vh;
  background: #f8fafc;
  overflow: hidden;
  min-width: 0;
  box-sizing: border-box;
}

.bar-section,
.table-section {
  margin-top: 4vh;
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  width: 100%;
  overflow-x: auto;
}

.table-section.no-bg {
  background: transparent;
  padding: 0;
  box-shadow: none;
}
</style>
